<template>
    <div class="navbar-fixed">
        <nav class="grey darken-4" role="navigation">
            <div class="nav-wrapper">
                <span class="brand-logo" :class="{noleft : noleft == 'true'}"><img src="/images/logo.png"/></span>
                <ul v-if="showMenu" class="right hide-on-med-and-down">

                    <router-link
                        to="/"
                        tag="li"
                        :class="{active : !trash}"
                    >
                        <a href="#"><i class="material-icons left">list</i>Projects</a>
                    </router-link>
                     <router-link
                        to="/trash"
                        tag="li"
                        :class="{active : trash}"
                    >
                        <a href="#"><i class="material-icons left" style="font-size: 20px;">delete_outline</i>Trash</a>
                    </router-link>
                    <li>
                        <a @click="onLogOut" href="#"><i class="material-icons left" style="font-size: 18px;">exit_to_app</i>Log Out</a>
                    </li>
                </ul>
                <v-progress-linear v-if="loading" indeterminate color="teo-orange" height="2"></v-progress-linear>
            </div>
        </nav>
    </div>
</template>

<script>
export default {
    name: "NavBar",
    props:['shared', 'noleft', 'trash'],
    data () {
        return {
            showMenu: true
        }
    },
    computed: {
        loading () {
            return this.$store.getters.loading;
        }
    },
    methods: {
        onLogOut (){
            this.$store.dispatch('logoutUser')
            .then(() => {
                this.$router.push('/login');
            })
            .catch(() => {});
        }
    },
    created () {
        if (this.shared == 'true') this.showMenu = false;
    }
};
</script>
